const BASE_URL = '/api/search-internet';

export default () => ({
  address: '',
  showError: false,
  searchResults: [],

  init() {
    this.address = '';
    this.showError = false;
    this.searchResults = [];
  },

  performSearch() {
    if (this.address.trim() === '') {
      this.searchResults = [];
      return;
    }

    if (this.address.trim().length < 3) {
      this.searchResults = [];
      return;
    }

    this.showError = false;

    fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ address: this.address }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.searchResults = data.results;
      })
      .catch((error) => {
        this.searchResults = 'Error occurred during search.';
      });
  },

  showMessage() {
    this.showError = true;
  },
});
